import { Popover } from '@tencent/udesign/dist';
import { useState } from 'react';
import { ITableFilterCustom } from '../../model';
import { renderFilterLabel, renderFilterLayerWrap } from './func';

interface IProps<T> {
  readonly onChanged: (key: string, value: string | string[]) => void;
  readonly columnKey: string;
  readonly value: string | string[];
  readonly filters: ITableFilterCustom<T>;
}

export function FilterCustomComponent<T>(props: IProps<T>) {
  const [value, setValue] = useState<string | string[]>('');

  const onClick = (action: 'reset' | 'ok') => {
    props.onChanged(props.columnKey, action === 'reset' ? '' : value);
  };

  return (
    <Popover
      content={renderFilterLayerWrap(
        props.filters.children(setValue, value),
        onClick
      )}
      placement="bottom"
      visible={false}
      destroyOnClose={true}
      trigger="click"
      className="filter-popover-box"
    >
      {renderFilterLabel(props.filters.icon, props.value)}
    </Popover>
  );
}
